import Joi from 'joi';
import _ from 'lodash';
import { sdkChartConfigEditorDefinitionSchema } from '../../common/joi-validation-schemas';
export const validateSDKChartConfigEditorDefinition = (sdkChartConfigEditorDefinitionList, logger) => {
    try {
        if (!_.isArray(sdkChartConfigEditorDefinitionList)) {
            throw new Error('chartConfigEditorDefinition is not an array');
        }
        _.each(sdkChartConfigEditorDefinitionList, sdkChartConfigEditorDefinition => {
            Joi.assert(sdkChartConfigEditorDefinition, sdkChartConfigEditorDefinitionSchema);
        });
    }
    catch (err) {
        logger?.error('chartConfigEditorDefinition is invalid', err);
        return false;
    }
    return true;
};
//# sourceMappingURL=util.js.map